import apiService from "./api";

const emailService = {
  // Send email batch
  sendEmailBatch(data) {
    return apiService.post('/send-email-batch', data);
  },
};

export default emailService;
